import useInView from "../../../Components/ScrollAnimation";
const ServicesCardInformation = ({ cardItems }) => {
    const [scrollView, setScrollView] = useInView()
    return (
        <>
            <h2
                ref={scrollView}
                className={`pl-[50px] pt-[30px] font-bold text-[35px] text-[#1b4a78] transition-all duration-700 ${setScrollView ? "animate-slideDown opacity-100" : "opacity-0"
                    }`}
            >
                What Sets Us Apart

            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 p-6 md:p-12 bg-gradient-to-br  min-h-screen">

                {cardItems.map((item, index) => (
                    <div
                        key={index}
                        className="from-blue-50 to-indigo-50  border border-white/20 rounded-2xl p-8 
      shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500
      cursor-pointer"
                    >


                        <h3 className="text-xl font-semibold text-gray-800 mb-2">
                            {item.title}
                        </h3>

                        <p className="text-gray-600">
                            {item.description}
                        </p>
                    </div>
                ))}
            </div>
        </>


    )
}
export default ServicesCardInformation